<template>
  <div>
    <h1 class="common__main-title">A Tutor’s Personal Information register confirm</h1>
    <div class="common__sub-title">
      <span>Details</span>
      <span class="common__sub-title-tag">Register New</span>
    </div>
    <div class="common__main-contener">
      <ConfirmForm :tutor="tutor" class="mb-5"/>
      <div class="d-flex justify-content-between">
        <b-button
          pill
          variant="secondary"
          :to="{
            name:'TutorAdd',
            params: { editingTutor: this.$route.params.editingTutor }
          }"
        >
          Back
        </b-button>
        <b-button
          pill
          variant="primary"
          @click="createTutor"
        >
          Register
        </b-button>
      </div>
    </div>
    <SuccessModal @ok="success" ref="sucessModal" />
    <ErrorModal @ok="error" ref="errorModal" />
    <Loading :isLoading="isLoading"/>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import ConfirmForm from '@/components/parts/tutor/ConfirmForm.vue';
import SuccessModal from '@/components/parts/modal/Success.vue';
import ErrorModal from '@/components/parts/modal/Error.vue';
import Loading from '@/components/parts/modal/Loading.vue';
import moment from 'moment';

export default Vue.extend({
  data() {
    return {
      isLoading: false,
      tutor: JSON.parse(this.$route.params.editingTutor),
    };
  },

  components: {
    ConfirmForm,
    SuccessModal,
    ErrorModal,
    Loading,
  },

  methods: {
    /* チューターの登録 */
    createTutor() {
      if (this.isLoading) {
        return
      }
      this.isLoading = true;

      this.$store.dispatch('registerTutor', {
        ...this.tutor,
        hireDate: this.tutor.hireDate && moment(this.tutor.hireDate),
        birthday: this.tutor.birthday && moment(this.tutor.birthday),
        leaveDate: this.tutor.leaveDate && moment(this.tutor.leaveDate),
      })
        .then(() => {
          (this.$refs.sucessModal as SuccessModal).open();
        })
        .catch((error) => {
          (this.$refs.errorModal as ErrorModal).open(error.response.data.message);
        })
        .finally(() => {
          this.isLoading = false;
        })
    },

    /* 成功モーダルのOKボタン押下時の処理 */
    success() {
      this.$router.push({ name: 'TutorList' });
    },

    error() {
      this.$router.push({
        name: 'TutorAdd',
        params: { editingTutor: this.$route.params.editingTutor },
      });
    },
  },
})
</script>
